/* RESPONSIBLE TEAM: team-tickets-1 */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    channel: {
      key: 'channel_id',
      serialize: 'ids',
      deserialize: 'ids',
    },
    notificationTypes: {
      serialize: 'ids',
      deserialize: 'ids',
    },
  },
});
